export default ({ axios, mapQueryString }) => ({
    index: (query = {}) => axios.get(`/reports/activity-statistics${mapQueryString(query)}`)
})